import React, { useEffect, useState } from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DataTable from "react-data-table-component";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { ArrowDownward } from "@material-ui/icons";
import yellow from "@material-ui/core/colors/yellow";
import { Link } from "react-router-dom";
import { helpers } from "../../helper/helper";
import Swal from "sweetalert2";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(32),
      height: theme.spacing(16),
    },
  },
  yellowPaper: {
    backgroundColor: yellow[300],
  },
  customBorder: {
    border: `3px solid ${yellow[200]}`,
  },
  customBorderRadius: {
    borderRadius: 10,
    marginTop: 30 
  },
  btn: {
    margin: theme.spacing(4)
  }
}));

const List = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const [page2, setPage2] = useState(1);
  const [perPage2, setPerPage2] = useState(10);
  const [totalRows2, setTotalRows2] = useState(0);

  const [list, setList] = useState([]);
  const [list2, setList2] = useState([]);
  const classes = useStyles();

  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(""); // approve / reject / complete / view
  const [rejectReason, setRejectReason] = useState("");
  const [paidBy, setPaidBy] = useState("");
  const [paidTo, setPaidTo] = useState("");
  const [transactionMethod, setTransactionMethod] = useState("");
  const [transactionUtr, setTransactionUtr] = useState("");
  const [transactionTime, setTransactionTime] = useState("");
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);

  const resetPaymentFields = () => {
    setPaidBy("");
    setPaidTo("");
    setTransactionMethod("");
    setTransactionUtr("");
    setTransactionTime("");
    setPaymentScreenshot(null);
  };

  const getPaymentFieldValue = (row, ...keys) => {
    for (const key of keys) {
      const value = row?.[key];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }
    return "";
  };

  const setPaymentFieldsFromRow = (row) => {
    setPaidBy(getPaymentFieldValue(row, "paidBy"));
    setPaidTo(getPaymentFieldValue(row, "paidTo"));
    setTransactionMethod(getPaymentFieldValue(row, "transactionMethod"));
    setTransactionUtr(getPaymentFieldValue(row, "transactionUtr"));
    setTransactionTime(getPaymentFieldValue(row, "transactionTime"));
    setPaymentScreenshot(
      getPaymentFieldValue(row, "paymentScreenshot", "paymentScreenshotUrl", "screenshot")
    );
  };

  const openActionModal = (row, type) => {
    setSelectedRow(row);
    setActionType(type);
    setRejectReason("");
    resetPaymentFields();
    if (type === "view") {
      setPaymentFieldsFromRow(row);
    }
    setShowModal(true);
  };

  const closeActionModal = () => {
    setShowModal(false);
    setSelectedRow(null);
    setActionType("");
    setRejectReason("");
    resetPaymentFields();
  };

  const columns = [
    {
      name: "User Name",
      selector: (row) => (
        <Link
          to={`/dashboard/users/update/details/${row?.userId?._id}`}
          style={{ textDecoration: "none", fontWeight: "600" }}
        >
          {row?.userId?.name}
        </Link>),
      wrap: true,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row?.amount || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => {
        const statusMap = {
          0: { label: "Pending", color: "warning" },
          1: { label: "Approved", color: "success" },
          2: { label: "Rejected", color: "danger" }
        };
        const status = statusMap[row?.status] || { label: "Unknown", color: "secondary" };
        return (
          <span className={`badge bg-${status.color} p-2`}>{status.label}</span>
        )
      },
      wrap: true,
      sortable: true,
    },
    {
      name: "Reject Reason",
      selector: (row) => row?.adminReason || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(new Date(row.createdAt)).format('DD-MM-YYYY'),
      wrap: true,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        // <div>
        //   <Link>
        //     <IconButton
        //       edge="end"
        //       aria-label="edit"
        //       onClick={() => {
        //         setSelectedRow(row);
        //         setShowModal(true);
        //       }}
        //     >
        //       <EditIcon color="primary" />
        //     </IconButton>
        //   </Link>
        // </div>
        <div className="d-flex gap-2">

          <button
            className="btn btn-success btn-sm mr-2"
            onClick={() => {
              openActionModal(row, "approve");
            }}
          >
            Accept
          </button>

          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              openActionModal(row, "reject");
            }}
          >
            Reject
          </button>

        </div>
      ),
      wrap: true,
      sortable: false
    }
  ];

  const columnsCompleted = [
    {
      name: "User Name",
      selector: (row) => (
        <Link
          to={`/dashboard/users/update/details/${row?.userId?._id}`}
          style={{ textDecoration: "none", fontWeight: "600" }}
        >
          {row?.userId?.name}
        </Link>),
      wrap: true,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row?.amount || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => {
        const statusMap = {
          0: { label: "Pending", color: "warning" },
          3: { label: "Processing", color: "secondary" },
          1: { label: "Approved", color: "success" },
          2: { label: "Rejected", color: "danger" }
        };
        const status = statusMap[row?.status] || { label: "Unknown", color: "secondary" };
        return (
          <span className={`badge bg-${status.color} p-2`}>{status.label}</span>
        )
      },
      wrap: true,
      sortable: true,
    },
    {
      name: "Reject Reason",
      selector: (row) => row?.adminReason || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(new Date(row.createdAt)).format('DD-MM-YYYY'),
      wrap: true,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-2">
          {row?.status === 3 ? (
            <button
              className="btn btn-success btn-sm mr-2"
              onClick={() => {
                openActionModal(row, "complete");
              }}
            >
              Should be completed
            </button>
          ) : null}
          {row?.status === 1 ? (
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                openActionModal(row, "view");
              }}
            >
              View
            </button>
          ) : null}
          {row?.status !== 3 && row?.status !== 1 ? "-": null}
        </div>
      ),
      wrap: true,
      sortable: false
    },
  ];

  useEffect(() => {
    getListOfRewards();
    getListOfCompletedRewards();
  }, []);

  const getListOfRewards = async (pageNumber = page, pageLimit = perPage) => {
    const url = `users/admin/withdraw-requests?page=${pageNumber}&limit=${pageLimit}`;
    const result = await helpers.apiCall("GET", url);
    if (result && result.success) {
      setList(result && result.data ? result.data : []);
      setTotalRows(result.total);
    }
  };

  const getListOfCompletedRewards = async (pageNumber = page, pageLimit = perPage) => {
    const url = `users/admin/withdraw-request-completed?page=${pageNumber}&limit=${pageLimit}`;
    const result = await helpers.apiCall("GET", url);
    if (result && result.success) {
      console.log('result.total', result.total)
      setList2(result && result.data ? result.data : []);
      setTotalRows2(result.total);
    }
  };

  const updateStatus = async () => {
    try {
      const url = `users/admin/withdraw-approve/${selectedRow._id}`;
      let res;

      if (actionType === "complete") {
        const formData = new FormData();
        formData.append("status", "approved");
        formData.append("paidBy", paidBy.trim());
        formData.append("paidTo", paidTo.trim());
        formData.append("transactionMethod", transactionMethod.trim());
        formData.append("transactionUtr", transactionUtr.trim());
        formData.append("transactionTime", transactionTime);
        formData.append("paymentScreenshot", paymentScreenshot);
        res = await helpers.apiCallForm("PUT", url, formData);
      } else {
        const payload = {
          status: actionType === "approve" ? "processing" : "rejected",
          reason: actionType === "reject" ? rejectReason : ""
        };
        res = await helpers.apiCall("PUT", url, payload);
      }

      console.log('res?.data?.result?.message', res?.data?.result?.message)
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Status Updated Successfully",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res?.data?.result?.message,
          confirmButtonColor: "#d33",
          confirmButtonText: "OK"
        });
      }

      // console.log('res.status', res.status)
      // Swal.fire({
      //   icon: "success",
      //   title: "Success",
      //   text: "Status Updated Successfully",
      //   confirmButtonColor: "#3085d6",
      //   confirmButtonText: "OK"
      // });

      closeActionModal();

      getListOfRewards();
      getListOfCompletedRewards();

    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
    getListOfRewards(page, perPage);
  };
  
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    getListOfRewards(page, newPerPage);
  };


  const handlePage2Change = (page2) => {
    setPage2(page2);
    getListOfCompletedRewards(page2, perPage);
  };
  
  const handlePerRowsChange2 = (newPerPage, page2) => {
    setPerPage2(newPerPage);
    getListOfCompletedRewards(page2, newPerPage);
  };

  console.log('totalRows2', totalRows2)
  console.log('list2', list2)
  return (
    <React.Fragment>

      <h2 style={{ marginTop: "50px", marginBottom: "10px" }}>
        Pending Withdraw Requests
      </h2>
      <Paper className={classes.customBorderRadius} elevation={15}>
        <DataTable
          columns={columns}
          data={list}
          defaultSortField="createdAt"
          pagination
          paginationServer
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          sortIcon={sortIcon}
          noHeader={true}
          striped={true}
          highlightOnHover={true}
          responsive={true}
        />
      </Paper>
      <Modal
        show={showModal}
        onHide={closeActionModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {actionType === "approve"
              ? "Approve Request"
              : actionType === "complete"
                ? "Complete Request"
                : actionType === "view"
                  ? "Payment Details"
                  : "Reject Request"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {actionType === "approve" && (
            <p className="text-center">
              Are you sure you want to <b className="text-success">Approve</b> this request?
            </p>
          )}

          {actionType === "complete" && (
            <>
              <p className="text-center">
                Please add payment details to mark this request <b className="text-success">Completed</b>.
              </p>
              <div className="mb-2">
                <label className="mb-1">Paid By</label>
                <input
                  type="text"
                  className="form-control"
                  value={paidBy}
                  onChange={(e) => setPaidBy(e.target.value)}
                  placeholder="Enter paid by"
                />
              </div>
              <div className="mb-2">
                <label className="mb-1">Paid To</label>
                <input
                  type="text"
                  className="form-control"
                  value={paidTo}
                  onChange={(e) => setPaidTo(e.target.value)}
                  placeholder="Enter paid to"
                />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction Method</label>
                <input
                  type="text"
                  className="form-control"
                  value={transactionMethod}
                  onChange={(e) => setTransactionMethod(e.target.value)}
                  placeholder="Enter transaction method"
                />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction UTR</label>
                <input
                  type="text"
                  className="form-control"
                  value={transactionUtr}
                  onChange={(e) => setTransactionUtr(e.target.value)}
                  placeholder="Enter transaction UTR"
                />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={transactionTime}
                  onChange={(e) => setTransactionTime(e.target.value)}
                />
              </div>
              <div>
                <label className="mb-1">Payment Screenshot</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => setPaymentScreenshot(e.target.files?.[0] || null)}
                />
              </div>
            </>
          )}

          {actionType === "view" && (
            <>
              <div className="mb-2">
                <label className="mb-1">Paid By</label>
                <input type="text" className="form-control" value={paidBy || "-"} readOnly />
              </div>
              <div className="mb-2">
                <label className="mb-1">Paid To</label>
                <input type="text" className="form-control" value={paidTo || "-"} readOnly />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction Method</label>
                <input type="text" className="form-control" value={transactionMethod || "-"} readOnly />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction UTR</label>
                <input type="text" className="form-control" value={transactionUtr || "-"} readOnly />
              </div>
              <div className="mb-2">
                <label className="mb-1">Transaction Time</label>
                <input
                  type="text"
                  className="form-control"
                  value={transactionTime ? moment(new Date(transactionTime)).format("DD-MM-YYYY hh:mm A") : "-"}
                  readOnly
                />
              </div>
              <div>
                <label className="mb-1 d-block">Payment Screenshot</label>
                {typeof paymentScreenshot === "string" && paymentScreenshot ? (
                  <a href={paymentScreenshot} target="_blank" rel="noreferrer">
                    <img
                      src={paymentScreenshot}
                      alt="payment-screenshot"
                      style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "8px" }}
                    />
                  </a>
                ) : (
                  <p className="mb-0">-</p>
                )}
              </div>
            </>
          )}

          {actionType === "reject" && (
            <>
              <p>
                Please enter reason for <b className="text-danger">Rejection</b>
              </p>

              <textarea
                className="form-control"
                rows="3"
                placeholder="Enter reject reason"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
            </>
          )}

        </Modal.Body>

        <Modal.Footer>

          <button
            className="btn btn-secondary"
            onClick={closeActionModal}
          >
            Cancel
          </button>

          {actionType !== "view" ? (
            <button
              className={`btn ${actionType === "reject" ? "btn-danger" : "btn-success"
                }`}
              onClick={() => {

                if (actionType === "reject" && !rejectReason) {
                  Swal.fire({
                    icon: "warning",
                    title: "Reject Reason Required",
                    text: "Please enter reject reason before rejecting.",
                  });
                  return;
                }

                if (actionType === "complete") {
                  if (
                    !paidBy.trim() ||
                    !paidTo.trim() ||
                    !transactionMethod.trim() ||
                    !transactionUtr.trim() ||
                    !transactionTime ||
                    !paymentScreenshot
                  ) {
                    Swal.fire({
                      icon: "warning",
                      title: "All Payment Fields Required",
                      text: "Please fill paidBy, paidTo, transactionMethod, transactionUtr, transactionTime and paymentScreenshot.",
                    });
                    return;
                  }
                }

                updateStatus();
              }}
            >
              Confirm
            </button>
          ) : null}

        </Modal.Footer>

      </Modal>

      <h2 style={{ marginTop: "50px", marginBottom: "10px" }}>
        Processed Withdraw Requests
      </h2>

      <Paper className={classes.customBorderRadius} elevation={15}>
        <DataTable
          columns={columnsCompleted}
          data={list2}
          defaultSortField="createdAt"
          pagination
          paginationServer
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          paginationTotalRows={totalRows2}
          paginationPerPage={perPage2}
          onChangePage={handlePage2Change}
          onChangeRowsPerPage={handlePerRowsChange2}
          sortIcon={sortIcon}
          noHeader={true}
          striped={true}
          highlightOnHover={true}
          responsive={true}
        />
      </Paper>
    </React.Fragment>
  )
};

export default List;